export default "__VITE_ASSET__8b80019f__"